import React from 'react';
import GoogleMeSis from "../assets/GoogleMe.png";

function GoogleMe() {
  return (
    <section className='bg-[#F7F3F2]'>
      <div
        style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 90%, 0 100%)',
          backgroundColor: '#2E2D2B',
          padding: '20px',
          width: '100%',
        }}
      >
        <div className="mx-auto w-full max-w-7xl px-5 py-12 md:py-16">
          <div className="grid items-center gap-10 md:gap-20 md:grid-cols-2">
            <div className='max-w-md mx-auto md:mx-0 text-center md:text-left'>
              <h2 className="mb-6 text-2xl font-bold md:text-3xl md:leading-snug">
                PROVEN <span className='italic text-black bg-[#CFF098]'>CHECKLIST</span> FOR GOOGLE RANKING SUCCESS
              </h2>
              <p className="mb-8 max-w-lg text-sm text-white sm:text-base md:mb-10 font-light">
                Let us help you foster genuine engagement and build an authentic online presence. If you're looking for a freelance web developer website partner, we offer comprehensive services. <br /> <br />
                For a limited time, you can get the <span className='font-bold'>Google Ranking Playbook</span> filled with the secrets our SEO specialists use to rank our clients' #1 on Google <span className='font-bold'>for just $29</span>, and you can also get <span className='font-bold'>$100 off our services.</span> This can be a great first step before you hire freelance web developer.
              </p>
              <div className="flex justify-center md:justify-start">
                <a href='/playbook'>
                  <button className="text-black bg-[#CFF098] rounded-full px-6 py-3 border-[1px] border-black">Purchase Playbook</button>
                </a>
              </div>
            </div>
            <div>
              <img src={GoogleMeSis} alt="Google Me Sis E-book Cover - Her Growth Co" className="mx-auto inline-block w-full max-w-md" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GoogleMe;